<template>
  <v-dialog v-model="dialog" width="600px" persistent max-height="80vh">
    <BaseBodyDialog title="Thêm tiêu chí đánh giá" :loading="loading" @close="close" @save="save">
      <v-form class="mt-6" ref="form" v-model="valid" lazy-validation>
        <BaseInput
          isRequiredTitle
          label="Tên tiêu chí đánh giá"
          placeholder="Nhập tên tiêu chí đánh giá"
          v-model="title"
          :rules="[$rules.required]"
        />
        <v-select
          isRequiredTitle
          item-text="text"
          item-value="value"
          label="Loại tiêu chí"
          placeholder="Chọn loại tiêu chí"
          :items="typeOptions"
          v-model="type"
          :rules="[$rules.required]"
          outlined
          dense
        >
          <template #label>
            <span>Loại tiêu chí<strong class="red--text ml-1">*</strong></span>
          </template>
        </v-select>
        <v-switch v-model="isRequired" label="Bắt buộc"></v-switch>
        <v-card v-if="type === 'multiplechoice' || type === 'singlechoice'" outlined class="mt-4">
          <v-card-title class="d-flex justify-space-between align-center py-2 px-4">
            <div class="subtitle-1 font-weight-bold">Các lựa chọn</div>
            <v-btn color="primary" outlined small @click="addSelection">
              <v-icon left small>mdi-plus</v-icon>
              Thêm
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-list dense>
              <v-list-item v-for="(selection, index) in selections" :key="index">
                <v-list-item-content>
                  <v-text-field
                    outlined
                    v-model="selections[index]"
                    :rules="[$rules.required]"
                    dense
                    hide-details="auto"
                    placeholder="Nhập lựa chọn"
                  ></v-text-field>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small color="error" @click="removeSelection(index)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-form>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'
import BaseButton from '@/components/basic/BaseButton.vue'
import BaseInput from '@/components/basic/BaseInput.vue'
import { mapActions } from 'vuex'

export default {
  components: { BaseBodyDialog, BaseButton, BaseInput },
  data() {
    return {
      dialog: false,
      valid: true,
      title: '',
      type: '',
      isRequired: false,
      selections: [],
      typeOptions: [
        { text: 'Đánh giá tự nhập', value: 'string' },
        { text: 'Đánh giá theo điểm số', value: 'number' },
        { text: 'Đánh giá theo tiêu chí (chọn nhiều)', value: 'multiplechoice' },
        { text: 'Đánh giá theo tiêu chí (chọn một)', value: 'singlechoice' },
      ],
      loading: false,
    }
  },
  methods: {
    ...mapActions('evaluateCriteria', ['createEvaluateCriteria']),
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.$refs.form.reset()
      this.selections = []
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          const criteriaData = {
            title: this.title,
            type: this.type,
            isRequired: this.isRequired,
            selections: this.selections,
            slug: this.title.toLowerCase().replace(/ /g, '-'),
          }
          await this.createEvaluateCriteria(criteriaData)
          this.$alert.success('Tạo tiêu chí đánh giá thành công')
          this.$emit('criteriaCreated')
          this.close()
        } catch (error) {
          this.$alert.error('Tạo tiêu chí đánh giá thất bại')
        } finally {
          this.loading = false
        }
      }
    },
    addSelection() {
      this.selections.push('')
    },
    removeSelection(index) {
      this.selections.splice(index, 1)
    },
  },
}
</script>
